// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3xwFe","label":"Section_label__3WSEq","contentWrap":"Section_contentWrap__2gHyc","footer":"Section_footer__t_3T3","footerInner":"Section_footerInner__a31mZ"};